export const GET_STATUS_MAP = 'getStatusMap';
export const GET_STATUS_BY_ID = 'getStatusById';
export const GET_STATUS_FETCHING = 'getStatusFetching';
